import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './EmployeeCalendar.css';
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import swal from 'sweetalert';
import { Link, useParams } from 'react-router-dom';
import { environment } from '../../environment';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, ButtonGroup, Container } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Loader from '../Home/loader/loader';
import { blue } from '@mui/material/colors';

const EmployeeCalendar = () => {

  const [loading, isLoading] = useState(false);
  const [priceField, setpriceField] = useState(0);
  var selectedDateTermins = [];
  const [isOpen, setisOpen] = useState(false);
  const [singleDateTermins, setSingleDateTermins] = useState([]);
  const [spinnerLoading, setspinnerLoading] = useState(false)

  const [pages, setPages] = useState(1); 
  const [size, setsize] = useState(5);
  const getAllTerminsUrl = `${environment.LOCALHOST_URL}/termin/all-termins?page=${pages}&size=${size}`;

  const [allTermins, setallTermins] = useState([]);
  const [fullTermins, setFullTermins] = useState([]);
    

  const [termins, setTermins] = useState([]);
  const [sortedTerminsFromFirstToLast, seTsortedTerminsFromFirstToLast] = useState([])
  let todayDate = moment().format('DD-MM-YYYY');

  function handleTerminDelete (id) {
    setspinnerLoading(true);
    const deleteUrl = `${environment.LOCALHOST_URL}/termin/delete/${id}`;
    axios(deleteUrl, {
      method: 'POST',
      headers: {
              'Content-Type': 'application/json',
            }
    })
        .then(() => {
          swal({
            title: `Termini u fshi me sukses`,
            buttons: {
              cancel: 'Mbyll',
            },
          })
            setspinnerLoading(false);
            
            setInterval(() => {
              window.location.reload();
            }, 4000)

        })
        .catch((error) => {
            console.error(error);
        });
      }

  const todaysTermins = termins.filter(
    (termin) => termin.terminDate === todayDate
  );

    const handleSizeChange = (e) => {
        setsize(e.target.value)
    }

  const handleNextPage = async () => {
    setPages(pages + 1);
  }

  const handlePrevPage = async () => {
    setPages(pages - 1);
    if (pages <= 1) {
        setPages(1);
    }
  }
  

  let sortedTermins = todaysTermins.sort((a, b) =>
    a.terminHour
      .split('/')
      .reverse()
      .join()
      .localeCompare(b.terminHour.split('/').reverse().join())
  );


  useEffect(() => {
    isLoading(true);
    axios
      .get(getAllTerminsUrl)
      .then((response) => {
        setTermins(response.data.allTermins);
        setFullTermins(response.data.fullTermins);
        seTsortedTerminsFromFirstToLast(response.data.sortedTerminsFromFirstToLast);
        setallTermins(response.data.fullTermins);
        isLoading(false);
        console.log(response.data.fullTermins)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [getAllTerminsUrl]);


    useEffect(() => {
      isLoading(true);
        axios
        .get(getAllTerminsUrl)
        .then((response) => {
          setallTermins(response.data.fullTermins);
          isLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }, [])


  const noEvents = [
      { title: 'Nuk ka termine', start: new Date() },
    ]

  const today = moment().format('DD-MM-YYYY');
  const filteredTermins = allTermins.filter(
    (termin) => termin.terminDate === today
  );
  

  var todaysEvents = [];

  const all = filteredTermins.map((termin) => {
    todaysEvents.push({ title: termin.email ? termin.clientName : termin.client, start: new Date(), color: blue });
  });

  // var events = [];
  // todaysEvents.forEach((event) => {
    // events.push({ title: event.title, start: event.start, color: blue });
  // });

  const events = allTermins.map((termin) => ({
    title: termin.email ? termin.clientName : termin.client,
    start: moment(termin.terminDate + ' ' + termin.terminHour, 'DD-MM-YYYY hh:mm').toDate(),

}));


  function renderEventContent(eventInfo) {
    return (
      <>
        <b>{eventInfo.start}</b>
        <i>{eventInfo.event.title}</i>
      </>
    );
  }



  const handleDateClick = (arg) => {
    setisOpen(true);
    
     selectedDateTermins = allTermins.filter(
      (termin) => termin.terminDate === moment(arg.dateStr).format('DD-MM-YYYY')
      );
      setSingleDateTermins(selectedDateTermins);
    };

    function handleConfirm(id){
      setspinnerLoading(true);

      const confirmUrl = `${environment.LOCALHOST_URL}/termin/confirm/${id}`;
      axios(confirmUrl, {
        method: 'POST',
        headers: {
                'Content-Type': 'application/json',
              }
      })
          .then(() => {
              setspinnerLoading(false);
              window.location.reload();
          })
          .catch((error) => {
              console.error(error);
          });
        }
 
        function price(e) {
          setpriceField(e.target.value);
          console.log({price:e.target.value })
        }

    function handleConfirmAcc(id){
      setspinnerLoading(true)
      const confirmAccUrl = `${environment.LOCALHOST_URL}/termin/confirmacc/${id}`;
      axios(confirmAccUrl, {
        method: 'POST',
        headers: {
                'Content-Type': 'application/json',
              }
      })
          .then((termin) => {
              setspinnerLoading(false)
              window.location.reload();

          })
          .catch((error) => {
              console.error(error);
          });
        }
 


    function handlePaguaj(id) {
      const payUrl = `${environment.LOCALHOST_URL}/termin/pay/${id}`;
      setspinnerLoading(true);
      axios(payUrl, {
        method: 'POST',
        headers: {
                'Content-Type': 'application/json',
              },
        data : {
          price : priceField
        }
      })
          .then(() => {
            setspinnerLoading(false);
          })
          .catch((error) => {
              console.error(error);
          });
    }
    
    function handlePaguajAcc(id) {
      setspinnerLoading(true);

      const payUrl = `${environment.LOCALHOST_URL}/termin/payAcc/${id}`;
      isLoading(true);
      
      axios(payUrl, {
        method: 'POST',
        headers: {
                'Content-Type': 'application/json',
              },
        data : {
          price : priceField
        }
      })
          .then(() => {
            setspinnerLoading(false);
              isLoading(false);
      
            })
          .catch((error) => {
              console.error(error);
          });
    }


  return (
    <>
    {
      loading ? <Loader /> : 
      <div className={isOpen ? 'employees-termin-table-black' : 'employees-termin-table'}>
        {isOpen && <div className='modals' style={{zIndex: 1000, position:'absolute'}}>
        <Button id='x-button' variant='contained' onClick={()=> setisOpen(false)}>X</Button>

          {singleDateTermins.length > 0 ? singleDateTermins.map((termin,i)=> (
              <div className='termin-accordions'>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>{termin.client}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      {termin.clientTel} - {termin.terminHour}
                    </Typography>

                    <div style={{margin: '10px', gap:'10px', border:'none' }}>
                    <ButtonGroup  variant="contained" aria-label="outlined primary button group">
                      {termin.clientEmail ? 
                      <Button onClick={(id)=> handleConfirmAcc(termin._id)} disabled={termin.confirmed === true}
                      className={termin.confirmed ? "btn btn-success" : "btn-btn warning"}> {termin.confirmed ? 'E konfirmuar' : "Konfirmo"} </Button>

                      :

                      <Button onClick={(id)=> handleConfirm(termin._id)} disabled={termin.confirmed === true}
                      className={termin.confirmed ? "btn btn-success" : "btn-btn warning"}> {termin.confirmed ? 'E konfirmuar' : "Konfirmo"} </Button>

                      }
                      

                       {
                        <Box
                        component="form"
                        sx={{
                          '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                        />}
                        <div>
                          <TextField
                          type='number'
                          onChange={price}
                          required
                          id="outlined-required"
                          defaultValue="0"
                          />
                        </div>
                        {termin.clientEmail ? 
                           <Button onClick={(id) => handlePaguajAcc(termin._id)}  disabled={priceField < 1 || termin.isPaid } > {termin.isPaid ? "E paguar" : "Paguaj"} </Button>
                          :
                          <Button onClick={(id) => handlePaguaj(termin._id)}  disabled={priceField < 1 || termin.isPaid } > {termin.isPaid ? "E paguar" : "Paguaj"} </Button>
                          
                        }
                        <button onClick={(id) => handleTerminDelete(termin._id)} className='btn btn-danger'> Anulo </button>
                    </ButtonGroup>
                        {
                          spinnerLoading ? <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div> : ""
                        }
                    </div>
                  </AccordionDetails>
                </Accordion>
       
            </div>


            
          )): <div className='no-termins'> Nuk ka termine {singleDateTermins}  </div>}
                  <Link to={`/termin`}> 
                    <button className='btn btn-warning'>Shto Termin</button>
                  </Link>        
              </div>}

        <h2 style={{textAlign: 'center'}}>Tabela e termineve</h2>


        <div className="container">

          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            views={['dayGridMonth', 'dayGridWeek', 'dayGridDay']}
            events={events.length !== 0 ? events : noEvents}
            headerToolbar={{
              start: 'prev today next',
              center: 'title',
              end: 'dayGridMonth dayGridWeek dayGridDay',
            }}
            eventContent={renderEventContent}
            dateClick={handleDateClick}
          />
        </div>

      

      </div>
    }

      <Container>

      <table className="table">
        <thead>
          <tr>
            <th scope="col">Termin ID</th>
            <th scope="col">Klienti</th>
            <th scope="col">Tel</th>
            <th scope="col">Data e terminit</th>
            <th scope="col">Data e regjistrimit</th>
            <th scope="col">Ora</th>
            <th scope="col">Menaxho</th>
          </tr>
        </thead>
        <tbody>

            {
              sortedTerminsFromFirstToLast.map((termin) => (
                <tr>
                  <th scope="row">{termin._id}</th>
                  <td>{termin.client}</td>
                  <td>{termin.clientTel}</td>
                  <td>{termin.terminDate}</td>
                  <td>{moment(termin.createdAt).format("DD-MM-YY hh:mm")}</td>
                  <td>{termin.terminHour}</td>
                  <td> <Link to={`/termin/single/${termin._id}`}> <button className='btn btn-warning' style={{width:'100%'}}>Edit </button>  </Link> </td>
                </tr>
              ))
            }
        </tbody>
      </table>
      </Container>
    </>
    
  );
              
};

export default EmployeeCalendar;
